export default "__VITE_ASSET__pY_$9at8__"